// extracted by mini-css-extract-plugin
export var quillEditor = "_nd-1";
export var variable = "_nd-0";